import PropTypes from 'prop-types'

const AlignPropType = PropTypes.oneOf(['left', 'right', 'center'])

export default AlignPropType
